module.exports = __webpack_public_path__ + "static/img/vFive3.81a4198.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vFive3.png
// module id = OKlj
// module chunks = 2